module.exports = __webpack_public_path__ + "static/media/WinRed-full-red.0c98ea6e.png";